export const formInitialValues = {
  q: "",
  city: "",
  filter_events_only: false,
  plzStart: "",
  plzEnd: "",
  startNumber: "",
  endNumber: "",
  eventSelect: "",
  branchSelect: "",
  savedFilters: null,
};

export const BREAKPOINT = "850px";
